import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    callout:
      'We check your identity document. If you wish to modify any information, please ',
    contactUs: 'contact us',
  },
  fr: {
    callout:
      'Nous vérifions votre document d’identité. Si vous souhaitez modifier des informations, ',
    contactUs: 'contactez-nous',
  },
} as const);
